<template>
  <div class="help_butt_joint">
    <el-dialog
      class="butt_joint_dialog"
      title="发布需求"
      :visible.sync="dialogParams.dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="form" label-position="left" ref="form">
        <el-form-item
          label="需求标题"
          prop="name"
          :rules="[{required:true,message:'请输入标题', trigger: 'blur'}]"
        >
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="预算金额(元)">
          <el-input v-model="form.budget"></el-input>
        </el-form-item>
        <el-form-item label="截止时间">
          <el-date-picker
            v-model="form.term_date"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="需求描述">
          <el-input type="textarea" v-model="form.synopsis"></el-input>
        </el-form-item>
        <!-- <el-form-item
          label="联系人手机号"
          prop="mobile"
          :rules="[
                      {required:true,message:'请输入联系人手机号', trigger: 'blur'},
                       {pattern: /^1[0-9]{10,10}$/, message: '手机号格式错误'}
                      ]"
          class="mobile_and_code"
        >
          <div class="mobile_and_code_flex">
            <el-input v-model="form.mobile" class="mobile" placeholder="请输入11位手机号"></el-input>
            <el-input v-model="form.mobileCode" class="code" placeholder="短信验证码"></el-input>
            <el-button @click="sendCode" v-show="!downcount">发送验证码</el-button>
            <el-button v-show="downcount">验证码（{{times}}）</el-button>
          </div>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogParams.dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit()">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 图片验证码对话框 -->
    <yzm_alert :yzmObj="yzmObj" v-on:setDwoncountSwitch="downcoutStart"></yzm_alert>
  </div>
</template>

<script>
import yzm_alert from "@/components/yzm_alert/yzm_alert";
export default {
  components: {
    yzm_alert
  },
  props: {
    dialogParams: {
      type: Object
    }
  },
  data() {
    return {
      form: {
        name: "",
        synopsis: "",
        term_date: "",
        // mobile: "",
        // mobileCode: "",
        budget: "",
        active: true
      },
      yzmObj: {
        mobile: null,
        dialogVisible: null,
        type: "MobileCodeTypeAuthentication"
      },
      downcount: false, //倒计时切换开关
      times: 60, //倒计时时间
      timer: null //定时器
    };
  },
  computed: {
    info() {
      return this.$store.state.info;
    },
    parkInfo(){
      return this.$store.state.parkInfo;
    }
  },
  created() {
    this.needInfo();
  },
  methods: {
    /* 监测个人信息 */
    needInfo() {
      let watchAch = this.$watch("info", (val, oldVal) => {
        if (val) {
          this.$set(this.form, "mobile", val.mobile);
          watchAch(); //取消监听
        }
      });
    },
    /*** 提交form*/
    submit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.saveData();
        } else {
          this.$message.error("请检查必填项");
          return false;
        }
      });
    },
    /** 保存*/
    saveData() {
      let params = Object.assign({}, this.form,{
        type:'DemandTypPushDemand',
        incubator:this.$store.state.parkInfo.id,
        mobile:this.info.mobile
      });
      this.api.pushDemand(params).then(res => {
        if(res.error.err_code === 0){
          this.dialogParams.dialogFormVisible = false;
          Object.assign(this.$data.form, this.$options.data().form)
        }
      });
      
    },
    /**发送验证码 */
    sendCode() {
      if (!this.downcount) {
        if (!/^1[0-9]{10,10}$/.test(this.form.mobile)) {
          this.$message("手机号格式不正确！");
          return;
        }
        this.yzmObj.mobile = this.form.mobile;
        this.yzmObj.dialogVisible = true;
      } else {
        this.$message("请不要重复点击");
      }
    },
    /**
     * 发送验证码切换倒计时
     * */
    downcoutStart(data) {
      if (data) {
        this.downcount = true;
        clearInterval(this.timer);
        this.times = 60;
        this.timer = setInterval(() => {
          this.times--;
          if (this.times === 0) {
            clearInterval(this.timer);
            this.timer = false;
            this.downcount = false;
          }
        }, 1000);
      }
    }
  }
};
</script>

<style lang="scss">
.help_butt_joint {
  .butt_joint_dialog .el-dialog {
    width: 500px;
  }

  .butt_joint_dialog .el-dialog__body {
    padding: 10px 40px;
  }

  .butt_joint_dialog .el-dialog__body .el-form .el-form-item {
    margin-bottom: 10px;
  }

  .butt_joint_dialog .el-dialog__body .el-form .el-form-item label {
    display: block;
    float: none;
  }

  .butt_joint_dialog
    .el-dialog__body
    .el-form
    .el-form-item
    .el-form-item__content {
    margin-left: 0px;
  }

  .butt_joint_dialog
    .el-dialog__body
    .el-form
    .el-form-item.mobile_and_code
    .mobile_and_code_flex {
    display: flex;
    justify-content: space-between;
  }

  .butt_joint_dialog
    .el-dialog__body
    .el-form
    .el-form-item.mobile_and_code
    .el-input.mobile {
    width: 200px;
  }

  .butt_joint_dialog
    .el-dialog__body
    .el-form
    .el-form-item.mobile_and_code
    .el-input.code {
    width: 100px;
  }

  .butt_joint_dialog
    .el-dialog__body
    .el-form
    .el-form-item
    .el-date-editor.el-input {
    width: 100%;
  }
}
</style>
